import backend from '@common/backend';

import { IBookSnapshotIn } from '../models/Books/Book';
import { groupFromBE } from './groups';
import { programFromBE } from './programs';

const BASE = '/books';

const bookToBE = ({ book_type, programs, groups, ...book }: any) => ({
	// @TODO: Remove when BE will be fixed
	...book,
	book_type_id: book_type.id,
	groups: groups?.map((item: any) => item.id),
});

export const bookFromBe = (book: any) => ({
	...book,
	programs: book.programs?.map(programFromBE),
	groups: book.groups.map(groupFromBE),
});

export const getBooks = async (query: any, options: any) =>
	backend
		.get(`${BASE}/`, {
			params: query,
			...options,
		})
		.then((books: any) => books.map(bookFromBe));

export const postBook = async (data: IBookSnapshotIn) => backend.post(`${BASE}`, bookToBE(data));

export const getBook = async (id: number) => backend.get(`${BASE}/${id}`).then(bookFromBe);

export const updateBook = async (id: number, data: any) =>
	backend.post(`${BASE}/${id}`, bookToBE(data)).then(bookFromBe);

export const deleteBook = async (id: number) => backend.delete(`${BASE}/${id}`);
